/* Overtime combo. Pricing is enforced by the Yampi promotion, never by this script. */
(() => {
  'use strict';
  const aggregate = (selections, attempt) => {
    const items = new Map();
    selections.forEach(({ variant }) => {
      const key = String(variant.id);
      if (items.has(key)) items.get(key).quantity += 1;
      else items.set(key, { id: variant.id, quantity: 1, properties: { _overtime_combo: attempt, _overtime_offer: 'esportivo-2-259' } });
    });
    return [...items.values()];
  };
  const validate = (selections, allowRepeat) => {
    const errors = selections.map(s => !s.product ? 'Escolha o modelo deste relógio.' : !s.variant ? 'Escolha a cor / variante deste relógio.' : !s.variant.available ? 'Esta variante está indisponível. Escolha outra cor.' : '');
    if (selections.every(s => s.variant) && String(selections[0].variant.id) === String(selections[1].variant.id)) {
      if (!allowRepeat) errors[1] = 'Escolha uma variante diferente para o segundo relógio.';
      else if (Number(selections[0].variant.limit) < 2) errors[1] = 'Só há uma unidade desta variante disponível. Escolha outra para o segundo relógio.';
    }
    return errors;
  };
  const confirmedAttempt = (cart, items, attempt) => items.every(expected =>
    cart.items.filter(line => String(line.variant_id) === String(expected.id) && line.properties?._overtime_combo === attempt)
      .reduce((sum, line) => sum + line.quantity, 0) === expected.quantity
  ) && cart.items.filter(line => line.properties?._overtime_combo === attempt).reduce((n, line) => n + line.quantity, 0) === 2;
  const suggestionsFor = (products, rankedIds) => {
    const selected = [];
    for (const id of rankedIds) {
      const product = products.find(p => String(p.id) === String(id));
      const variant = product?.variants.find(v => v.available && Number(v.limit) >= 1);
      if (variant && !selected.some(s => String(s.product.id) === String(id))) selected.push({ product, variant });
      if (selected.length === 2) break;
    }
    return selected;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { aggregate, validate, confirmedAttempt, suggestionsFor };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('overtime-combo')) return;

  class OvertimeCombo extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try { this.products = JSON.parse(this.querySelector('[data-combo-data]').textContent).products; }
      catch { this.querySelector('[data-global-error]').textContent = 'Não foi possível carregar os modelos. Atualize a página.'; return; }
      this.abort = new AbortController();
      this.selections = [{ product: null, variant: null }, { product: null, variant: null }];
      this.slots = [...this.querySelectorAll('[data-slot]')];
      this.busy = false;
      this.uncertain = false;
      this.started = false;
      this.viewSent = false;
      this.lastComplete = '';
      this.storageKey = 'ot-combo-selection:' + this.id;
      this.root = window.Shopify?.routes?.root || '/';
      this.listen(this, 'change', event => {
        const panel = event.target.closest('[data-slot]');
        if (!panel || this.busy) return;
        const slot = Number(panel.dataset.slot) - 1;
        if (event.target.matches('[data-model]')) this.chooseModel(slot, event.target.value);
        if (event.target.matches('[data-variant]')) this.chooseVariant(slot, event.target.value);
      });
      this.listen(this, 'click', event => {
        const variantButton = event.target.closest('[data-variant-button]');
        if (variantButton && !this.busy) this.chooseVariant(Number(variantButton.closest('[data-slot]').dataset.slot) - 1, variantButton.dataset.variantButton);
        const edit = event.target.closest('[data-edit]');
        if (edit) this.focusSlot(Number(edit.dataset.edit) - 1);
        if (event.target.closest('[data-buy]')) this.buy();
        if (event.target.closest('[data-mobile-action]')) {
          if (this.selections.every(s => s.variant)) this.buy();
          else this.focusSlot(this.selections.findIndex(s => !s.variant));
        }
      });
      this.listen(window, 'pageshow', () => { this.busy = false; this.setAttribute('aria-busy', 'false'); this.update(); });
      this.listen(document, 'visitorConsentCollected', () => this.trackView());
      const restored = this.restore();
      if (!restored) this.suggestBestSellers();
      this.update();
      this.trackView();
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => this.trackView());
      }
      // Keep the purchase bar away from Shopify's consent banner.
      this.consentBanner = document.querySelector('#shopify-pc__banner');
      if (this.consentBanner) {
        const positionBar = () => {
          const rect = this.consentBanner.getBoundingClientRect();
          const visible = rect.height > 0 && getComputedStyle(this.consentBanner).display !== 'none';
          this.querySelector('[data-mobile-bar]').style.bottom = visible ? `${rect.height}px` : '0';
        };
        this.bannerObserver = new MutationObserver(positionBar);
        this.bannerObserver.observe(this.consentBanner, { attributes: true, childList: true });
        this.listen(window, 'resize', positionBar);
        positionBar();
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.bannerObserver?.disconnect(); this.initialized = false; }
    listen(target, type, handler) { target.addEventListener(type, handler, { signal: this.abort.signal }); }
    trackView() { if (!this.viewSent) this.viewSent = this.track('viewed'); }
    track(action, extra = {}) {
      if (this.dataset.tracking !== 'true' || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || !window.Shopify?.analytics?.publish) return false;
      const payload = {
        offer_id: 'esportivo-2-259', currency: this.dataset.currency || 'BRL', offer_value: Number(this.dataset.price) / 100,
        items: this.selections.filter(s => s.variant).map(s => ({ item_id: String(s.product.id), item_variant: String(s.variant.id), item_name: s.product.title, variant_name: s.variant.title, quantity: 1, unit_price: s.variant.price / 100 })), ...extra
      };
      try { Promise.resolve(window.Shopify.analytics.publish(`overtime:combo_${action}`, payload)).catch(() => {}); return true; } catch { return false; }
    }
    start() { this.querySelector('[data-suggestion-note]')?.setAttribute('hidden', ''); if (!this.started) { this.started = true; this.track('started'); } }
    chooseModel(slot, id, restoring = false) {
      const product = this.products.find(p => String(p.id) === String(id)) || null;
      this.selections[slot] = { product, variant: null };
      const panel = this.slots[slot];
      panel.querySelector('[data-model]').value = product ? String(product.id) : '';
      const select = panel.querySelector('[data-variant]');
      select.replaceChildren(new Option(product ? 'Escolha uma cor / variante' : 'Escolha um modelo primeiro', ''));
      select.disabled = !product;
      const thumbs = panel.querySelector('[data-thumbnails]'); thumbs.replaceChildren();
      if (product) product.variants.forEach(variant => {
        const option = new Option(variant.title + (!variant.available ? ' — indisponível' : ''), String(variant.id));
        option.disabled = !variant.available;
        select.add(option);
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ot-thumb'; button.dataset.variantButton = variant.id;
        button.disabled = !variant.available; button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', variant.title + (!variant.available ? ' — indisponível' : ''));
        button.title = variant.title;
        const img = document.createElement('img'); img.src = variant.image || product.image; img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy';
        button.append(img); thumbs.append(button);
      });
      this.renderImage(slot);
      panel.querySelector('[data-details]').hidden = !product;
      panel.querySelector('[data-description]').textContent = product?.description || '';
      const link = panel.querySelector('[data-product-link]');
      if (product) link.href = product.url;
      if (!restoring) { this.start(); this.persist(); }
      this.update();
    }
    chooseVariant(slot, id, restoring = false) {
      const selection = this.selections[slot];
      selection.variant = selection.product?.variants.find(v => String(v.id) === String(id) && v.available) || null;
      this.slots[slot].querySelector('[data-variant]').value = selection.variant ? String(selection.variant.id) : '';
      this.renderImage(slot);
      if (!restoring) {
        this.start(); this.persist();
        if (selection.variant) this.track('watch_selected', { slot: slot + 1 });
      }
      this.update();
      if (!restoring && this.isComplete()) {
        const signature = this.selections.map(s => s.variant.id).join(':');
        if (signature !== this.lastComplete) { this.lastComplete = signature; this.track('completed'); }
      }
    }
    renderImage(slot) {
      const { product, variant } = this.selections[slot];
      const panel = this.slots[slot], image = panel.querySelector('[data-product-image]');
      image.hidden = !product; panel.querySelector('.ot-empty').hidden = !!product;
      if (product) { image.src = variant?.image || product.image; image.alt = product.title + (variant ? ' — ' + variant.title : ''); }
      panel.querySelector('[data-stage-name]').textContent = variant?.title || '';
    }
    isComplete() { return !validate(this.selections, this.dataset.repeat === 'true').some(Boolean); }
    update() {
      const errors = validate(this.selections, this.dataset.repeat === 'true');
      let count = 0;
      this.selections.forEach(({ product, variant }, slot) => {
        const panel = this.slots[slot], complete = !!variant && !errors[slot];
        if (complete) count++;
        panel.classList.toggle('is-complete', complete);
        panel.querySelectorAll('.ot-thumb').forEach(b => b.setAttribute('aria-pressed', String(!!variant && b.dataset.variantButton === String(variant.id))));
        panel.querySelector('[data-slot-error]').textContent = variant ? errors[slot] : '';
        panel.querySelector('[data-variant]').setAttribute('aria-invalid', String(!!variant && !!errors[slot]));
        panel.querySelector('[data-slot-status]').textContent = complete ? 'Escolhido. Você pode trocar quando quiser.' : product ? 'Escolha uma cor para completar esta seleção.' : 'Selecione um modelo para ver as cores.';
        const summary = this.querySelector(`[data-summary="${slot + 1}"]`);
        summary.querySelector('[data-summary-name]').textContent = product?.title || `Seu ${slot + 1}º relógio`;
        summary.querySelector('[data-summary-variant]').textContent = variant?.title || (product ? 'Falta escolher a cor' : 'Falta escolher');
        summary.querySelector('[data-edit]').textContent = product ? 'Editar' : 'Escolher';
        const image = summary.querySelector('img'); image.hidden = !product;
        summary.querySelector('.ot-summary-image span').hidden = !!product;
        if (product) image.src = variant?.image || product.image;
      });
      this.querySelectorAll('.ot-progress i').forEach((el, i) => el.classList.toggle('done', i < count));
      this.querySelector('[data-progress]').textContent = `${count} de 2 relógios escolhidos`;
      this.querySelector('[data-mobile-progress]').textContent = count === 2 ? 'Seus 2 relógios' : `${count} de 2 escolhidos`;
      const ready = this.dataset.ready === 'true' && this.dataset.currency === 'BRL';
      const buy = this.querySelector('[data-buy]');
      if (!this.buyLabel) this.buyLabel = buy.textContent;
      buy.disabled = this.busy || this.uncertain || count !== 2 || !ready;
      buy.textContent = this.busy ? 'Preparando seu combo…' : this.buyLabel;
      const mobile = this.querySelector('[data-mobile-action]');
      mobile.disabled = this.busy || this.uncertain || (count === 2 && !ready);
      mobile.textContent = this.busy ? 'Preparando…' : count === 2 ? 'Comprar meu combo' : 'Montar combo';
      this.querySelector('[data-checkout-note]').textContent = this.uncertain ? 'Confira o carrinho antes de tentar novamente.' : !ready ? 'Oferta em preparação. Compra disponível após validação do checkout.' : count !== 2 ? 'Escolha seus dois relógios para continuar.' : 'Os dois relógios serão enviados juntos ao seu carrinho.';
    }
    focusSlot(slot) {
      const panel = this.slots[Math.max(0, slot)];
      panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      panel.querySelector(this.selections[slot]?.product ? '[data-variant]' : '[data-model]').focus({ preventScroll: true });
    }
    persist() { try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.selections.map(s => ({ product: s.product?.id, variant: s.variant?.id })))); } catch {} }
    restore() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey));
        if (!Array.isArray(saved) || saved.length !== 2) return false;
        saved.forEach((s, slot) => { if (s?.product) { this.chooseModel(slot, s.product, true); if (s.variant) this.chooseVariant(slot, s.variant, true); } });
        return true;
      } catch { return false; }
    }
    async suggestBestSellers() {
      if (!this.dataset.suggestions) return;
      try {
        const response = await fetch(this.dataset.suggestions, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
        if (!response.ok) return;
        const data = await response.json();
        if (data.sort !== 'best-selling' || !Array.isArray(data.products)) return;
        if (!this.isConnected || this.started || this.selections.some(s => s.product)) return;
        const suggestions = suggestionsFor(this.products, data.products);
        if (suggestions.length !== 2) return;
        suggestions.forEach(({ product, variant }, slot) => {
          this.chooseModel(slot, product.id, true);
          this.chooseVariant(slot, variant.id, true);
        });
        this.querySelector('[data-suggestion-note]').hidden = false;
      } catch {}
    }
    async request(path, options = {}) {
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 18000);
      try {
        const response = await fetch(this.root + path, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        const data = await response.json();
        if (!response.ok) throw Object.assign(new Error(data.description || data.message || 'Não foi possível atualizar o carrinho.'), { status: response.status });
        return data;
      } finally { clearTimeout(timer); }
    }
    async buy() {
      if (this.busy || this.uncertain || !this.isComplete() || this.dataset.ready !== 'true' || this.dataset.currency !== 'BRL') return;
      this.busy = true; this.setAttribute('aria-busy', 'true');
      const errorBox = this.querySelector('[data-global-error]'); errorBox.textContent = '';
      this.update();
      let submitted = false;
      const attempt = crypto.randomUUID ? crypto.randomUUID() : `ot-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const items = aggregate(this.selections, attempt);
      try {
        // A fresh product response catches catalog changes; Shopify performs the final stock validation.
        const fresh = await Promise.all(this.selections.map(s => this.request(s.product.url.replace(this.root, '').replace(/^\//, '') + '.js')));
        fresh.forEach((product, slot) => {
          const variant = product.variants.find(v => String(v.id) === String(this.selections[slot].variant.id));
          if (!variant?.available) throw new Error('Uma das cores acabou de ficar indisponível. Escolha outra e tente novamente.');
          this.selections[slot].variant.price = variant.price;
        });
        const before = await this.request('cart.js');
        if (before.currency !== 'BRL') throw new Error('Este combo está disponível em reais. Selecione BRL para continuar.');
        submitted = true;
        try { await this.request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) }); }
        catch (addError) {
          // Network failure can occur after a successful add. Reconcile, never retry the mutation.
          const afterError = await this.request('cart.js').catch(() => null);
          if (!afterError || !confirmedAttempt(afterError, items, attempt)) throw addError;
        }
        const cart = await this.request('cart.js');
        if (!confirmedAttempt(cart, items, attempt)) throw new Error('Não foi possível confirmar os dois relógios. Confira o carrinho antes de continuar.');
        this.track('added_to_cart', { event_id: attempt, cart_value: cart.total_price / 100, value: this.selections.reduce((n, s) => n + s.variant.price, 0) / 100 });
        this.track('checkout_requested', { event_id: attempt });
        const next = new URL(this.root + 'cart', window.location.origin);
        next.searchParams.set('ref', 'overtime_combo');
        // Yampi's installed snippet owns the redirect and its supported attribution parameters.
        if (window.Shopify?.customerPrivacy?.marketingAllowed?.()) {
          const current = new URL(window.location.href);
          ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(key => {
            if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
          });
        }
        window.location.assign(next.href);
      } catch (error) {
        // A partial batch or uncertain network outcome must be inspected instead of added again.
        this.uncertain = submitted;
        errorBox.textContent = submitted ? 'Confira seu carrinho: a inclusão pode ter sido parcial. Não repetimos a operação para evitar itens duplicados.' : error.message;
        this.querySelector('.ot-cart-recovery').hidden = !submitted;
        this.track('error', { phase: submitted ? 'cart' : 'availability', error_code: error.status || 'request_failed' });
        this.busy = false; this.setAttribute('aria-busy', 'false'); this.update(); errorBox.focus();
      }
    }
  }
  customElements.define('overtime-combo', OvertimeCombo);
})();
